import React, { useState, useEffect, useRef } from "react"
import {
  DocumentDuplicateIcon,
  TrashIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline"
import { Editor } from "@tiptap/core"

import { clearLinkFromDOM } from "./editor/text_helpers"
import HoverBubbleMenu from "../../../../components/hover_bubble_menu"

export default function LinkBubble({
  wrapperRef,
  editor,
}: {
  wrapperRef: React.RefObject<HTMLDivElement | null>
  editor: Editor
}) {
  const clearLink = (hoverElement) => {
    clearLinkFromDOM(editor, hoverElement)
  }

  return (
    <HoverBubbleMenu selector="a" wrapperRef={wrapperRef}>
      {(hoverElement) => {
        if (hoverElement.getAttribute("href") == null) return null
        return (
          <div className="flex items-stretch justify-between gap-4 w-96 px-3 py-2 z-10 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 shadow rounded text-sm">
            <a
              target="_blank"
              className="block font-medium text-ellipsis truncate"
              href={hoverElement.getAttribute("href") || "#"}
            >
              {hoverElement.getAttribute("href")}
            </a>
            <div className="flex items-center gap-1 text-gray-700 dark:text-gray-100">
              <div
                onClick={() => {
                  if (navigator.clipboard)
                    navigator.clipboard.writeText(
                      hoverElement.getAttribute("href")!
                    )
                }}
                className="hover:text-sky-700 cursor-pointer"
              >
                <DocumentDuplicateIcon className=" w-4 h-4" />
              </div>
              <div
                onClick={() => clearLink(hoverElement)}
                className="hover:text-sky-700 cursor-pointer"
              >
                <TrashIcon className=" w-4 h-4" />
              </div>
            </div>
          </div>
        )
      }}
    </HoverBubbleMenu>
  )
}
